module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-button', {
    staticClass: "base-icon-button",
    class: {
      plain: _vm.plain
    },
    attrs: {
      "type": _vm.type,
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('div', {
    staticClass: "flex items-center gap-x-2"
  }, [_c(_vm.icon, {
    tag: "component",
    attrs: {
      "color": _vm.iconColor,
      "size": _vm.iconSize
    }
  }), _vm._v("\n    " + _vm._s(_vm.label) + "\n    "), (_vm.appendIcon) ? [_c(_vm.appendIcon, {
    tag: "component",
    attrs: {
      "color": _vm.iconColor,
      "size": _vm.iconSize
    }
  })] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13260c18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/BaseIconButton.vue
// module id = 1473
// module chunks = 159